<template>
    <div class="full-parent">
        <embed v-if="typeFile == TYPE_FILE_PDF" :src="apiUrl + path" class="full-parent" />
        <!-- <iframe v-if="typeFile == TYPE_DOCUMENT" class="full-parent" :src="`https://docs.google.com/gview?url=${apiUrl + path}&embedded=true`" frameborder="0">
            </iframe> -->
            <iframe v-if="typeFile == TYPE_DOCUMENT" class="full-parent" :src="`https://view.officeapps.live.com/op/embed.aspx?src=${apiUrl + path}`" frameborder="0">
            </iframe>
    </div>

</template>
<script>
import {
    TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
    TYPE_FILE_PDF, TYPE_FILE_POWERPOINT, TYPE_FILE_WORD, TYPE_FILE_EXCEL, TYPE_FILE_IMAGE
} from './../constants/constants_enum'
import VueDocPreview from 'vue-doc-preview'
import { APP_CONFIG } from "@/utils/constants";

export default {
    components: {
        VueDocPreview
    },
    props: {
        path: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: ''
        },
        
    },
    watch: {
        'path':'checkFile'
    },
    data() {
        return {
            TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
            TYPE_FILE_PDF, TYPE_FILE_POWERPOINT, TYPE_FILE_WORD, TYPE_FILE_EXCEL, TYPE_FILE_IMAGE,
            apiUrl: APP_CONFIG.apiUrl + '/lessons/',
           // apiUrl: 'https://apihanhtrangso-uat.hiser.vn/lessons/',//APP_CONFIG.apiUrl + '/lessons/',
            typeFile: 0,
            listTypeDocument: [
                { value: TYPE_H5P, text: 'Bài giảng tương tác H5P' },
                { value: TYPE_DOCUMENT, text: 'Dạng tài liệu' },
                { value: TYPE_TEST, text: 'Dạng kiểm tra' },
                { value: FILE_YOUTUBE, text: 'Dạng youtube' },
                { value: FILE_CANVA, text: 'Dạng canva' },
                { value: FILE_LINK, text: 'Dạng nhúng' },
            ],
            mdStyle: {
                img: {
                    'display': 'none'
                },
                code: {
                    'background-color': 'red',
                    'line-height': '20px'
                }
            }
        }
    },
    mounted() {
        this.checkFile()
        console.log(this.path)
    },
    methods: {
        checkFile(){
            console.log(this.path)
            if (this.path.endsWith('.pdf')) {
                this.typeFile = TYPE_FILE_PDF
            }
            else if(this.path.endsWith('.jpeg')||this.path.endsWith('.jpg')||this.path.endsWith('.gif')||this.path.endsWith('.png')){
                this.typeFile = TYPE_FILE_IMAGE
            }else{
                this.typeFile = TYPE_DOCUMENT
            }
        },
        emberYoutube(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);
            return `https://www.youtube.com/embed/${(match && match[2].length === 11)
                ? match[2]
                : null}`
        }
    }
}
</script>

<style lang="scss" scoped>
.full-parent {
    width: 100% !important;
    height: 100% !important;
}
.question{
    padding: 10px;
        border: 1px solid #dfb6b6;
        border-radius: 15px;
        background: #dfb6b6;
}
.list-answer{
        padding: 10px;
        border: 1px solid #dde3e6;
        border-radius: 15px;
        background: white;
    }
.over-flow-auto {
    overflow: auto;
    
}
.justify-content-space-between{
    justify-content: space-between;
}
</style>